// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Contact__wrapper___1FHFB","page-title":"Contact__page-title___8ibsl typography__title___3pJfO","email":"Contact__email___1l67Y","form-wrapper":"Contact__form-wrapper___1HPk3","hide":"Contact__hide___37JuG","label":"Contact__label___2l15j","input":"Contact__input___3cZjI","button":"Contact__button___4-1PO"};


//////////////////
// WEBPACK FOOTER
// ./application/js/pages/Contact.css
// module id = 527
// module chunks = 0